"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backoffRetryPolicy = exports.getOrRetry = void 0;
const actions_core_1 = require("@segment/actions-core");
const delay_1 = require("./delay");
const getOrCatch_1 = require("./getOrCatch");
async function getOrRetry(action, args) {
    const retryIntervalMs = args?.retryIntervalMs === undefined ? backoffRetryPolicy() : args?.retryIntervalMs ?? 1000;
    return (0, getOrCatch_1.getOrCatch)(async () => await (0, actions_core_1.retry)((attempt) => action(attempt), {
        retries: args?.attempts,
        async onFailedAttempt(error, attemptCount) {
            if (args?.onFailedAttempt)
                await args.onFailedAttempt(error, attemptCount);
            const intervalMs = typeof retryIntervalMs == 'function' ? retryIntervalMs(attemptCount, error) : retryIntervalMs;
            if (intervalMs > 0)
                await (0, delay_1.delay)(intervalMs);
        }
    }));
}
exports.getOrRetry = getOrRetry;
function backoffRetryPolicy(initialDelayMs = 500, multiplier = 1) {
    return (attempt) => initialDelayMs * attempt * multiplier;
}
exports.backoffRetryPolicy = backoffRetryPolicy;
//# sourceMappingURL=getOrRetry.js.map